import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <img
              src="https://public.readdy.ai/ai/img_res/1abbfbd7-97ad-49cf-b76f-1b8793713d8e.png"
              alt="NEMT Services Logo"
              className="h-12 w-auto object-contain"
            />
          </div>

          <div className="hidden md:flex items-center space-x-10">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-800 hover:text-teal-600' : 'text-white hover:text-teal-200'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-800 hover:text-teal-600' : 'text-white hover:text-teal-200'
              }`}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('vehicles')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-800 hover:text-teal-600' : 'text-white hover:text-teal-200'
              }`}
            >
              Vehicle Types
            </button>
            <button
              onClick={() => scrollToSection('insurance')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-800 hover:text-teal-600' : 'text-white hover:text-teal-200'
              }`}
            >
              Insurance &amp; Coverage
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-800 hover:text-teal-600' : 'text-white hover:text-teal-200'
              }`}
            >
              About Us
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-800 hover:text-teal-600' : 'text-white hover:text-teal-200'
              }`}
            >
              Contact
            </button>
          </div>

          <div className="flex items-center space-x-4">
            <a
              href="tel:4019039036"
              className={`hidden lg:flex items-center space-x-2 text-sm font-medium whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              <i className="ri-phone-line text-lg"></i>
              <span>(401) 903-9036</span>
            </a>
            <button
              onClick={() => scrollToSection('contact')}
              className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'bg-teal-600 text-white hover:bg-teal-700'
                  : 'border-2 border-white text-white hover:bg-white hover:text-teal-600'
              }`}
            >
              Book Now
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
